enum DisbursementTypeEnum {
    OtherRetainedFunds = 'OTHER_RETAINED_FUNDS',
    PrepaidInterest = 'PREPAID_INTEREST',
    RetainedContingency = 'RETAINED_CONTINGENCY',
    RetainedFunds = 'RETAINED_FUNDS',
}

export default DisbursementTypeEnum;
